module.exports = __webpack_public_path__ + "img/ccc2.32264e3f.png";